
import classicaTemplate from './pousada-classica/template.json';
import premiumTemplate from './lodge-premium/template.json';
import aventuraTemplate from './aventura-esportiva/template.json';

export const TEMPLATES = [
  classicaTemplate,
  premiumTemplate,
  aventuraTemplate
];

export const getTemplateById = (id: string) => {
  return TEMPLATES.find(t => t.id === id) || TEMPLATES[0];
};
